import React, { useRef } from 'react';
import { QRCodeCanvas } from 'qrcode.react';

const QRDownloadButton = () => {
  const canvasRef = useRef(null);
  const qrValue = 'https://www.fie.undef.edu.ar/vae/index.html';

  const handleDownload = () => {
    const canvas = canvasRef.current;
    if (canvas) {
      const pngUrl = canvas.toDataURL('image/png');
      const link = document.createElement('a');
      link.href = pngUrl;
      link.download = 'qr-vae.png';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  return (
    <>
      <QRCodeCanvas
        ref={canvasRef}
        value={qrValue}
        size={300}
        bgColor="#ffffff"
        fgColor="#000000"
        level="H"
        includeMargin={true}
        style={{ display: 'none' }}
      />
      <button
        onClick={handleDownload}
        className="flex items-center gap-1 transition-colors duration-300 hover:text-secondary"
        title="Descargar código QR"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M3 3h4v4H3V3zm14 0h4v4h-4V3zm0 14h4v4h-4v-4zM3 17h4v4H3v-4zm5-10h2v2H8V7zm0 4h2v2H8v-2zm4-4h2v2h-2V7zm0 4h2v2h-2v-2zm-4 4h2v2H8v-2zm4 0h2v2h-2v-2zm4-4h2v2h-2v-2zm0 4h2v2h-2v-2z"
          />
        </svg>
        <span className="hidden sm:inline text-sm font-medium">QR</span>
      </button>
    </>
  );
};

export default QRDownloadButton;